export const TITLE_TRACKING_ATTRIBUTE = 'data-tracking-label';
//# sourceMappingURL=index.js.map